<template>
    <div>
        <div class="box">
            <div class="box-header"></div>
            <div class="box-body table-responsive no-padding">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>File Name</th>
                            <th>Date</th>
                            <th>Downloaded By</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in logList" :key="item.id">
                            <td>{{ item.fileName }}</td>
                            <td>{{ item.dateDownloaded | soiDate }}</td>
                            <td>{{ item.downloadedBy }}</td>
                            <!-- <td>
                        <TheDropDownButton>
                            <TheIconButton  @click.native="
                  downloadsoi(item.id, item.fileName, item.fileType, item.entryId)
                "
                                           icon="fa fa-download"
                                           title="Downloadable Profile"></TheIconButton>
                            put a delete button for crad users
                            <TheIconButton v-if="$store.getters.CRAD && item.canDelete"
                                           @click.native="deleteSOI(item.id, item.fileName, item.entryId)"
                                           icon="fa fa-trash"
                                           title="Delete Profile"></TheIconButton>
                        </TheDropDownButton>
                    </td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="box-footer clearfix">
                <b-pagination v-model="pagingInfo.page"
                              v-on:input="logs()"
                              :total-rows="totalitemslogs"
                              :per-page="pagingInfo.itemsPerPage"
                              first-text="First"
                              prev-text="Prev"
                              next-text="Next"
                              last-text="Last"></b-pagination>
            </div>
        </div>

    </div>
</template>
<script>
import {
    authHeader,
    responseCheck,
    RecordURL,
    notifyHelper,
    LogURL
} from "../../helper";
//import TheIconButton from "../buttons/iconButton";
import instance from "../../helper/http";
export default {
    data() {
        return {
            logList: [],
            pagingInfo: {
                id: null,
                page: 1,
                itemsPerPage: 10,
                
            },
            totalitemslogs: null,
        };
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        }
    },
    mounted: function () {
        this.logs();
    },
    components: {
        //TheIconButton,
    },
    methods: {
        logs: function () {
            let loader = this.$loading.show();
            this.pagingInfo.id = this.id;
            instance
                .get(LogURL + this.url, {
                    headers: authHeader(),
                    params: this.pagingInfo,
                })
                .then((response) => {
                    if (response.data.data) {
                        this.logList = response.data.data;
                        this.totalitemslogs = response.data.count;
                        loader.hide();
                        //fireup modal
                        //this.showModal();
                    } else {
                        loader.hide();
                        notifyHelper("warn", "logs not found");
                    }
                })
                .catch(function (error) {
                    responseCheck(error.response.status);
                });
        },
        fetchlogs(){
            let loader = this.$loading.show();
            this.pagingInfo.id = this.id;
            instance
                .get(RecordURL + this.url, {
                    headers: authHeader(),
                    params: this.pagingInfo,
                })
                .then((response) => {
                    if (response.data.withsoi) {
                        this.logList = response.data.data;
                        this.totalitems = response.data.count;
                        loader.hide();
                        //fireup modal
                        //this.showModal();
                    } else {
                        loader.hide();
                        notifyHelper("warn", "logs not found");
                    }
                })
                .catch(function (error) {
                    responseCheck(error.response.status);
                });
        }
    },
};
</script>

